/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { feePlansCreateFeePlanAgreements } from "../../funcs/feePlansCreateFeePlanAgreements.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateFeePlanAgreementsRequest$inboundSchema,
};

export const tool$feePlansCreateFeePlanAgreements: ToolDefinition<typeof args> =
  {
    name: "fee-plans-create-fee-plan-agreements",
    description:
      `Creates the subscription of a fee plan to a merchant account. Merchants are required to accept the fee plan terms prior to activation.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/profile.write\` scope.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await feePlansCreateFeePlanAgreements(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value.result;

      return formatResult(value, apiCall);
    },
  };
